const billingActionTypes = {
  GET_INVOCIES: "GET_INVOCIES",
  GET_INVOCIES_SUCCESS: "GET_INVOCIES_SUCCESS",
  GET_INVOCIES_FAIL: "GET_INVOCIES_FAIL",
};

export default billingActionTypes;
